import React from 'react'

export const LicensePrices = ({data, setData}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      licensePrices: { ...prev.licensePrices, [name]: value },
    }));
  };
  return (
    <div className="bg-[#f0f0f0] dark:bg-[#282828] p-4 rounded-lg my-4">
    <div className="flex items-center space-x-2">
      <div className="bg-[#FF93BB] w-4 h-4 rounded" />
      <h1>License Prices</h1>
    </div>
    <p className='opacity-60 py-2'>If you need more clarification around the licenses we offer, you can find our full license terms <span className='underline'>here</span></p>

    <div className='flex items-center justify-between space-x-2'>
      <div className='w-full'>
        <label htmlFor="">Personal</label>
        <div className='bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  w-full rounded-lg my-2 flex items-center p-2'>
          <input name='personal' value={data.licensePrices?.personal} onChange={handleChange} type="text" className='bg-transparent w-full' />
          $
        </div>
      </div>
      <div className='w-full'>
        <label htmlFor="">Commercial</label>
        <div className='bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  w-full rounded-lg my-2 flex items-center p-2'>
          <input name='commercial' value={data.licensePrices?.commercial} onChange={handleChange} type="text" className='bg-transparent w-full' />
          $
        </div>
      </div>
    </div>
    

    </div>
  )
}
